async function updateAllSubscriptionItems() {
  showLoader();

  try {
    const cartRes = await fetch("/cart.js");
    const cart = await cartRes.json();

    // Collect only items that need a plan and don’t already have one
    const itemsToUpdate = cart.items.filter(
      item => !item.selling_plan_allocation
    );

    // Process each item sequentially to avoid overwrites
    for (const item of itemsToUpdate) {
      const handle = item.handle || item.product_handle;
      if (!handle) continue;

      const productRes = await fetch(`/products/${handle}.js`);
      const product = await productRes.json();

      const variant = product.variants.find(v => v.id === item.variant_id);
      if (!variant?.selling_plan_allocations?.length) continue;

      const sellingPlanId = variant.selling_plan_allocations[0].selling_plan_id;

      console.log(`Updating item ${item.key} with plan ${sellingPlanId}`);

      // Update only this item
      await fetch("/cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          id: item.key,
          quantity: item.quantity,
          selling_plan: sellingPlanId
        })
      }).then(res => res.json())
        .then(updated => console.log(`Item ${item.key} updated`, updated))
        .catch(err => console.error(`Error updating ${item.key}:`, err));
    }

    console.log("All eligible items updated!");
    hideLoader();

    setTimeout(() => window.location.href = "/checkout", 200);
  } catch (err) {
    console.error("Error updating subscription items:", err);
    hideLoader();
  }
}

document.body.addEventListener("click", function(e) {
  if (e.target.matches("#subscribe-checkout-btn")) {
    e.preventDefault();
    e.target.disabled = true;
    updateAllSubscriptionItems();
  }
});
